module.exports = __webpack_public_path__ + "static/grant-wood-c6dea458922f2f3e7105d51836bc0f28.jpg";